import { IDropdownOption } from '@fluentui/react';

export enum ResourceType {
  AI_UNITS = 'ai_units',
  H2OGPTE_TOKENS = 'h2ogpte_tokens',
}

export const resourceOptions: IDropdownOption[] = [
  { key: ResourceType.AI_UNITS, text: 'AI Unit Usage' },
  { key: ResourceType.H2OGPTE_TOKENS, text: 'H2oGPTe Token Usage' },
];
